<section class="calendar-view">
    @if (!active && surveys.length === 0) {
    <p class="uscb-padding-T-0 uscb-padding-L-0 uscb-font-1x msg-p">No completed surveys</p>
    }
    @if (overdueMessage && overdueMessage.length > 0 && active) {
    <div class="ecorr-survey-card-overdue-message" tabindex="0">
        {{ overdueMessage }}
    </div>
    }

    <div class="uscb-margin-B-50">
        <div class="top-padding survey-cal-container uscb-layout-column-sm uscb-layout-column-md uscb-layout-column-lg uscb-layout-row-gt-lg">
            @if (surveys.length === 0) {
            <div></div>
            }

            @if (surveys.length > 0) {
            <div class="cal-panel">
                <div class="year-view fx-col fx-align-center-center">
                    @for (item of (yearViewData() || []); track item.year) {
                    <div class="year-row fx-row fx-align-center-stretch fx-flex-none">
                        <div class="year-view-year uscb-bold fx-col fx-align-center-center fx-flex-none">{{item.year}}</div>

                        <div class="fx-row-wrap fx-flex-auto">
                            @for (month of (item.months || []); track month.date) {
                            <div class="fx-flex-none ecorr-calendar-year-summary-month uscb-text-align-center ecorr-calendar-year-summary-{{ month.statusString }}"
                                    [ngClass]="{ 'year-view-month' : month.isActive, 'year-view-month-inactive' : !month.isActive, 'year-view-month-activemonth' : month.isActiveMonth }"
                                    [matTooltip]="month.toolTip" matTooltipClass="tooltip"
                                    (click)="monthClicked(month)" (keyup.enter)="monthClicked(month)">
                                <div tabindex="0">{{month.date | date: 'MMM'}}</div>
                            </div>
                            }
                        </div>
                    </div>
                    }
                </div>

                <div class="uscb-layout-row uscb-layout-align-space-between uscb-layout-align-vert-center">
                    <div class="ecorr-calendar-month uscb-layout-row uscb-layout-align-vert-center">
                        <div class="ecorr-calendar-month-label">
                            {{ activeMonth() | date: 'MMM yyyy' }}
                        </div>
                    </div>

                    <!-- export cal -->
                    <div class="uscb-layout-row uscb-layout-align-vert-center">
                        @if (exporting()) {
                        <ng-container>
                            <div class="cursor-progress"> Please wait. Loading... &nbsp;&nbsp; <i class="fa fa-spinner fa-spin fa-lg"></i>
                            </div>
                        </ng-container>
                        }

                        @if (!exporting()) {
                        <ng-container>
                            <div class="uscb-hide-sm uscb-layout-column uscb-padding-LR-5">
                                <button class="uscb-primary-button export-calendar-button" [disabled]="safariCheck()" (click)="showInstructions()" (keyup.enter)="showInstructions()" tabindex="0">
                                    Export Instructions
                                    <i class="fa fa-info-circle uscb-cursor-pointer-hover export-calendar-button-icon" [matTooltip]="exportCalInstrTooltipHtml | decodeXml" matTooltipClass="tooltip"></i>
                                </button>
                            </div>
                            <div class="uscb-hide-sm uscb-layout-column">
                                <button class="uscb-primary-button export-calendar-button" [disabled]="safariCheck()" (click)="generateCalendar()" (keyup.enter)="generateCalendar()" tabindex="0">
                                    Export
                                    <i class="fa fa-info-circle uscb-cursor-pointer-hover export-calendar-button-icon" [matTooltip]="exportCalTooltipHtml | decodeXml" matTooltipClass="tooltip"></i>
                                </button>
                            </div>
                        </ng-container>
                        }
                    </div>
                </div>

                <!-- Breakpoints must be explicitly separated because there are no breakpoint-specific versions of layout-wrap -->
                <div class="cal-month-header uscb-hide-md uscb-hide-sm uscb-hide-xs fx-row fx-align-start-stretch">
                    <div class="fx-flex">Sunday</div>
                    <div class="fx-flex">Monday</div>
                    <div class="fx-flex">Tuesday</div>
                    <div class="fx-flex">Wednesday</div>
                    <div class="fx-flex">Thursday</div>
                    <div class="fx-flex">Friday</div>
                    <div class="fx-flex">Saturday</div>
                </div>
                <div class="survey-cal-month">
                    @for (date of (dateList() && dateList()[0] ? dateList()[0] : []); track date) {
                    <app-calendar-view-instance class="survey-cal-day"
                        [date]="date"
                        [active]="active"
                        [ngClass]="{ 'inactive-month' : !date.isActiveMonth }">
                    </app-calendar-view-instance>
                    }
                </div>
            </div>

            @if (active) {
            <section class="survey-cards survey-cal-add padding-bottom-4em uscb-padding-0">
                <mat-card class="survey-card add-survey-card uscb-margin-10 uscb-layout-column" tabindex="0">
                    <mat-card-content class="uscb-flex-row">
                        <div class="uscb-position-absolute">
                            <div class="uscb-title-3">New Survey Request</div>
                            <div class="uscb-font-1x">{{addSurveyText}}</div>
                        </div>
                        <div class="uscb-position-relative ecorr-icon-background">
                            <i class="fa fa-plus-circle uscb-color-accent"></i>
                        </div>
                    </mat-card-content>
                    <div class="uscb-flex-row">
                        <mat-divider role="presentation"></mat-divider>
                    </div>
                    <mat-card-actions class="uscb-flex-row uscb-layout-column">
                        <div class="uscb-flex-row uscb-padding-10">
                            <button type="button" class="uscb-primary-button" (click)="addSurvey()" (keyup.enter)="addSurvey()" tabindex="0">
                                <i class="fa fa-plus-circle"></i> &nbsp; ADD AUTHENTICATION CODE
                            </button>
                        </div>
                    </mat-card-actions>
                </mat-card>
            </section>
            }
            }
        </div>
    </div>
</section>
